import axios from 'axios';
import keycloak from '../common/Keycloak';
import CryptoJS from 'crypto-js';
import alertifyjs from 'alertifyjs';

export default function setup() {
  if (keycloak.enableKavach) {
    axios.interceptors.request.use(function (config) {
      
      let userToken = window.localStorage.getItem('lmUserToken')
      let token = userToken ? userToken.replace(/"/g, '') : false;
      if (token && !config.headers.Authorization) {
        config.headers['x-auth-type'] = `lm-kavach-web`;
        config.headers.Authorization = `Bearer ${token}`;
        
        let userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
        let userDataKey = window.localStorage.getItem('userUniqueKey')
        if(userdetailEncrypt && userDataKey)
        {
          let bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), userDataKey);
          let plaintext = bytes.toString(CryptoJS.enc.Utf8);
          let userdetail = JSON.parse(plaintext);
          config.headers['id'] = userdetail.userid;
        }
      }

      

      return config;
    }, function (err) {
      return Promise.reject(err);
    });

    // Add a response interceptor
    axios.interceptors.response.use(function (response) {
      return response;
    },function (error) {
      let isLoggedIn = window.localStorage.getItem('isLoggedIn');
      if (error && error.response && error.response.status === 401) {
        let errorRes = ((error.response && error.response.data) ? error.response.data : {});
        // this.$alertify.error(errorRes.message);
        if(isLoggedIn){
          alertifyjs.error(errorRes.message);
          //alert(errorRes.message);
        }
        window.localStorage.setItem('isLoggedIn',false);
        // setTimeout(() => {
          keycloak.logoutWithTokenId();
        // }, 1000);
      } else {
        return Promise.reject(error);
      }
    });
  }
  return;
};


// WEBPACK FOOTER //
// ./src/common/requestInterceptor.js